import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

export const firebaseConfig = {
  apiKey: "AIzaSyDLwDsJWP95laVJxf6S0hCKD1hMSABAhug",
  authDomain: "pushtest-linkid.firebaseapp.com",
  databaseURL:
    "https://pushtest-linkid-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "pushtest-linkid",
  storageBucket: "pushtest-linkid.appspot.com",
  messagingSenderId: "108316572273",
  appId: "1:108316572273:web:b8b03cadd87b26ee7bb9d0",
  measurementId: "G-WKGJ9VTE8K",
};

const app = initializeApp(firebaseConfig);

// Get a reference to the database service
export const database = getDatabase(app);
